export function renderHero() {
  return `
    <section id="hero" class="relative min-h-screen pt-24 sm:pt-28 pb-8 px-6 lg:px-16 flex flex-col justify-between border-b border-[#1C201E] bg-tech-grid overflow-hidden">
      <!-- 3D WebGL Canvas Layer -->
      <div id="three-hero-container" class="absolute inset-0 w-full h-full pointer-events-auto z-0" role="region" aria-label="Interactive 3D WebGL showcase featuring cybernetic macropad, cyber-minimalist studio headset, and electric guitar"></div>

      <!-- Ambient Glow Behind 3D Stage -->
      <div class="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[650px] h-[350px] bg-cyan-500/5 rounded-full blur-[140px] pointer-events-none z-0"></div>

      <!-- Top Coordinate Markers -->
      <div class="relative z-10 max-w-7xl mx-auto w-full pt-1 flex justify-between items-center text-[10px] font-mono tracking-widest text-neutral-400 uppercase select-none">
        <div class="flex items-center gap-2">
          <span class="inline-block w-1.5 h-1.5 rounded-full bg-emerald-400"></span>
          <span>[ TIKER_21 // 80.77° E, 7.87° N ]</span>
        </div>
        <div class="hidden sm:block text-neutral-400 tracking-widest">
          <span>COLOMBO → TOKYO → SAN FRANCISCO</span>
        </div>
      </div>

      <!-- Center Main Title Block -->
      <div class="relative z-10 max-w-6xl mx-auto w-full my-auto py-6 sm:py-10 text-center pointer-events-none">
        <div class="inline-flex items-center gap-2 mb-6 px-3.5 py-1 rounded-none border border-white/15 bg-[#050505]/80 backdrop-blur-md pointer-events-auto">
          <span class="w-1.5 h-1.5 rounded-full bg-cyan-telemetry animate-pulse"></span>
          <span class="font-mono text-[11px] uppercase tracking-widest text-neutral-300">RANJIKA NETHPRIYA / CREATIVE WEB DEVELOPER · UI/UX · SYSTEMS · SRI LANKA</span>
        </div>

        <h1 class="text-6xl sm:text-8xl md:text-9xl font-bold tracking-tighter text-[#FAF8F5] uppercase leading-[0.88] select-none font-display">
          <span class="sr-only">Ranjika Nethpriya — Creative Web Developer, UI/UX Designer &amp; Full-Stack Engineer in Sri Lanka. </span>
          IDEAS <br/>
          <span class="font-serif italic normal-case text-amber-100 font-normal tracking-tight text-7xl sm:text-9xl md:text-[9.5rem] leading-[0.85] -mt-2 inline-block">into</span> <br/>
          SYSTEMS
        </h1>

        <!-- Action CTAs -->
        <div class="mt-8 flex flex-wrap items-center justify-center gap-4 text-xs font-mono pointer-events-auto">
          <a class="px-6 py-3 bg-[#FAF8F5] text-[#050505] font-semibold uppercase tracking-wider rounded-none hover:bg-ember hover:text-white transition-colors duration-150 shadow-[0_0_20px_rgba(240,234,220,0.12)] inline-flex items-center gap-2" href="#projects" aria-label="Open for projects — view selected works">
            <span>OPEN FOR PROJECTS</span>
            <span aria-hidden="true">↗</span>
          </a>
          <a class="px-6 py-3 border border-white/25 text-neutral-200 uppercase tracking-wider rounded-none hover:border-white hover:bg-white/5 transition-all duration-150 inline-flex items-center gap-2" href="#about" aria-label="Meet Ranjika — read background and experience">
            <span>MEET RANJIKA</span>
            <span aria-hidden="true">↓</span>
          </a>
        </div>

        <!-- 3D Interaction Cue -->
        <div class="mt-4 flex items-center justify-center gap-2 font-mono text-[10px] text-neutral-500 select-none tracking-widest uppercase pointer-events-auto">
          <span class="text-amber-200/80 text-xs">⇄</span>
          <span>CLICK &amp; HOLD TO ROTATE 3D HARDWARE</span>
        </div>
      </div>

      <!-- Hero Philosophical Kicker (Newsreader Italic per screen.png) -->
      <div class="relative z-10 max-w-4xl mx-auto w-full border-t border-[#1C201E] pt-5">
        <p class="font-serif italic text-xs sm:text-sm md:text-base text-neutral-300 text-center tracking-wide">
          "CODE IS THE MEDIUM. CURIOSITY IS THE ENGINE."
        </p>
      </div>
    </section>
  `;
}
